import React, {
  createContext,
  FC,
  useContext,
  useEffect,
  useState,
} from "react";
import { Post } from "../../types/Post";
import { Feed } from "./Feed";
import { xhr } from "../xhr";

const FeedContext = createContext<{ recentFeed: Post[]; homepageFeed: Post[] }>(
  {
    recentFeed: [],
    homepageFeed: [],
  }
);

export const useFeedContext = () => useContext(FeedContext);

export const FeedContextProvider: FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [feed, setFeed] = useState<Post[]>([]);
  const [homeFeed, setHomeFeed] = useState<Post[]>([]);
  const numOfHomepagePosts = 4;
  const numOfLatestPosts = 20;

  useEffect(() => {
    (async () => {
      const feedService = new Feed(xhr);
      if (!feed.length) {
        const posts = await feedService.getPosts();
        setFeed(feedService.slicePosts(posts, numOfLatestPosts));
        setHomeFeed(feedService.slicePosts(posts, numOfHomepagePosts));
      }
    })();
  }, [feed.length]);

  return (
    <FeedContext.Provider value={{ recentFeed: feed, homepageFeed: homeFeed }}>
      {children}
    </FeedContext.Provider>
  );
};
